import { gql } from '@apollo/client';

export const DELETE_REPORT = gql`
  mutation deleteReport($id: ID!) {
    deleteReportProfile(id: $id)
  }
`;
